"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ID_TYPE_SYSTEM_CODE_MAPPING = exports.ID_TYPE_ENUM_MAPPING = exports.PRIMARY_ID_TYPE = exports.ID_TYPES = void 0;
exports.getIdentificationTypeTemplateBySystemCode = getIdentificationTypeTemplateBySystemCode;
exports.getIdentificationTypeTemplate = getIdentificationTypeTemplate;
exports.getIdTypeTemplate = getIdTypeTemplate;
exports.getLocalePrimaryIdTypes = getLocalePrimaryIdTypes;
var entities_1 = require("@common/entities");
var DRIVERS_LICENSE_1 = require("./DRIVERS_LICENSE");
var GOVERNMENT_ISSUED_PICTURE_ID_1 = require("./GOVERNMENT_ISSUED_PICTURE_ID");
var MILITARY_ID_1 = require("./MILITARY_ID");
var OTHER_MISC_1 = require("./OTHER_MISC");
var PASSPORT_1 = require("./PASSPORT");
var SOCIAL_SECURITY_NUMBER_1 = require("./SOCIAL_SECURITY_NUMBER");
var STUDENT_IDENTIFICATION_NUMBER_1 = require("./STUDENT_IDENTIFICATION_NUMBER");
var VISA_1 = require("./VISA");
var GENERIC_TAX_ID_1 = require("./GENERIC_TAX_ID");
var DONT_HAVE_FIELD_NAME_1 = require("./DONT_HAVE_FIELD_NAME");
exports.ID_TYPES = [
    { value: entities_1.IDTypes.DriversLicense, label: 'Drivers License' },
    {
        value: entities_1.IDTypes.GovernmentIssuedPhotoId,
        label: 'Government Issued Picture Id',
    },
    { value: entities_1.IDTypes.MilitaryId, label: 'Military Id' },
    { value: entities_1.IDTypes.Passport, label: 'Passport' },
    {
        value: entities_1.IDTypes.StudentIdentificationNumber,
        label: 'Student Identification Number',
    },
    { value: entities_1.IDTypes.Visa, label: 'Visa' },
];
exports.PRIMARY_ID_TYPE = __spreadArray([
    { value: entities_1.IDTypes.SocialSecurityNumber, label: 'Social Security Number' }
], exports.ID_TYPES, true);
exports.ID_TYPE_ENUM_MAPPING = (_a = {},
    _a[entities_1.IDTypes.SocialSecurityNumber] = SOCIAL_SECURITY_NUMBER_1.SOCIAL_SECURITY_NUMBER,
    _a[entities_1.IDTypes.DriversLicense] = DRIVERS_LICENSE_1.DRIVERS_LICENSE,
    _a[entities_1.IDTypes.GovernmentIssuedPhotoId] = GOVERNMENT_ISSUED_PICTURE_ID_1.GOVERNMENT_ISSUED_PICTURE_ID,
    _a[entities_1.IDTypes.MilitaryId] = MILITARY_ID_1.MILITARY_ID,
    _a[entities_1.IDTypes.Passport] = PASSPORT_1.PASSPORT,
    _a[entities_1.IDTypes.StudentIdentificationNumber] = STUDENT_IDENTIFICATION_NUMBER_1.STUDENT_IDENTIFICATION_NUMBER,
    _a[entities_1.IDTypes.Visa] = VISA_1.VISA,
    _a);
exports.ID_TYPE_SYSTEM_CODE_MAPPING = {
    'DR LIC': DRIVERS_LICENSE_1.DRIVERS_LICENSE,
    'GOV ID': GOVERNMENT_ISSUED_PICTURE_ID_1.GOVERNMENT_ISSUED_PICTURE_ID,
    'MIL ID': MILITARY_ID_1.MILITARY_ID,
    VISA: VISA_1.VISA,
    'STAT ID': GOVERNMENT_ISSUED_PICTURE_ID_1.GOVERNMENT_ISSUED_PICTURE_ID,
    'PASS ID': PASSPORT_1.PASSPORT,
    'STUD ID': STUDENT_IDENTIFICATION_NUMBER_1.STUDENT_IDENTIFICATION_NUMBER,
};
function getIdentificationTypeTemplateBySystemCode(systemCode) {
    if (!(systemCode === null || systemCode === void 0 ? void 0 : systemCode.trim()))
        return undefined;
    return exports.ID_TYPE_SYSTEM_CODE_MAPPING[systemCode.trim().toUpperCase()];
}
var normalizeIdentificationType = function (value) {
    return value.trim().replace(/\s+/g, ' ').toLowerCase();
};
function getIdentificationTypeTemplate(value) {
    var _a;
    var normalizedValue = normalizeIdentificationType(value);
    if ([OTHER_MISC_1.OTHER_MISC.name, OTHER_MISC_1.OTHER_MISC.label, OTHER_MISC_1.OTHER_MISC.customType].some(function (candidate) { return normalizeIdentificationType(candidate) === normalizedValue; })) {
        return OTHER_MISC_1.OTHER_MISC;
    }
    return (_a = Object.entries(exports.ID_TYPE_ENUM_MAPPING).find(function (_a) {
        var key = _a[0], config = _a[1];
        return [key, config.name, config.label, config.customType].some(function (candidate) { return normalizeIdentificationType(candidate) === normalizedValue; });
    })) === null || _a === void 0 ? void 0 : _a[1];
}
function getIdTypeTemplate(idType, taxIdDetail) {
    var _a, _b, _c;
    var staticTemplate = exports.ID_TYPE_ENUM_MAPPING[idType];
    if (staticTemplate && !taxIdDetail)
        return staticTemplate;
    var label = (_a = taxIdDetail === null || taxIdDetail === void 0 ? void 0 : taxIdDetail.name) !== null && _a !== void 0 ? _a : idType;
    var abbreviation = (_b = taxIdDetail === null || taxIdDetail === void 0 ? void 0 : taxIdDetail.abbreviation) !== null && _b !== void 0 ? _b : idType;
    var taxIdTypeId = (_c = taxIdDetail === null || taxIdDetail === void 0 ? void 0 : taxIdDetail.id) !== null && _c !== void 0 ? _c : 0;
    if (staticTemplate && ((taxIdDetail === null || taxIdDetail === void 0 ? void 0 : taxIdDetail.id) === 1 || (taxIdDetail === null || taxIdDetail === void 0 ? void 0 : taxIdDetail.name) === staticTemplate.label)) {
        return __assign(__assign({}, staticTemplate), { taxIdTypeId: taxIdTypeId });
    }
    return (0, GENERIC_TAX_ID_1.buildTaxIdTemplate)({
        idType: abbreviation,
        name: label.toLowerCase().replace(/\s+/g, '_'),
        label: label,
        dontHaveLabel: "I don't have a ".concat(label, "."),
        dontHaveFieldName: (0, DONT_HAVE_FIELD_NAME_1.getDontHaveFieldName)(abbreviation),
        taxIdTypeId: taxIdTypeId,
    });
}
function getLocalePrimaryIdTypes(taxIdTypes) {
    if (!(taxIdTypes === null || taxIdTypes === void 0 ? void 0 : taxIdTypes.length))
        return exports.PRIMARY_ID_TYPE;
    var localeOptions = taxIdTypes.map(function (taxIdType) { return ({
        value: taxIdType.id === 1 ? entities_1.IDTypes.SocialSecurityNumber : taxIdType.abbreviation,
        label: taxIdType.name,
    }); });
    var seen = new Set();
    return __spreadArray(__spreadArray([], localeOptions, true), exports.ID_TYPES, true).filter(function (option) {
        if (seen.has(option.value))
            return false;
        seen.add(option.value);
        return true;
    });
}
